





















import Vue from 'vue'

interface CData {
  show: boolean
}

interface CMethods {
  articles(name: string): []
}
interface CComputed {
  routeName: any
  label: string
}

export default Vue.extend<CData, CMethods, CComputed, {}>({
  name: 'ReadMore',
  data() {
    return {
      show: false
    }
  },
  mounted() {
    this.show = this.articles(this.routeName).length > 0
  },
  watch: {
    routeName(value) {
      this.show = this.articles(value).length > 0
    }
  },
  methods: {
    articles(name) {
      const thisMenuItem = this.$store.getters.menu.find(
        (item: any) => item.slug === name
      )

      console.log('thisMenuItem',thisMenuItem);

      return (thisMenuItem?.children?.length > 0 && thisMenuItem.children) || []
    }
  },
  computed: {
    routeName() {
      return this.$route.name
    },
    label(){
      let texts = this.$store.getters.texts
      return texts.readMore;
    }
  }
})
